import type { MedicoFila } from "@/api/db/medico";
import { format } from "@/lib/format";
import { MedicoLabels } from "@/lib/labels/medico";

import { MetaLine, QueueRow, QueueSection } from "./queue-section";

function ArchivedManualRow({ manual }: { manual: MedicoFila["archivedManuals"][number] }) {
	const consultedAt = format.date(manual.consultationDate);
	const revokedAt = format.date(manual.revokedAt);

	return (
		<QueueRow>
			<div
				className="flex flex-col gap-1"
				data-component="archived-manual-row"
				data-manual={manual.id}
			>
				<p className="font-display text-sm font-medium text-foreground">
					{manual.patientName ?? MedicoLabels.archivedManuals.unknownPatient}
				</p>

				<MetaLine>
					<span className="font-mono">#{manual.id}</span>

					{!!consultedAt && (
						<span>
							{MedicoLabels.archivedManuals.consultationPrefix}{" "}
							<span className="font-mono">{consultedAt}</span>
						</span>
					)}

					{!!revokedAt && (
						<span>
							{MedicoLabels.archivedManuals.revokedPrefix}{" "}
							<span className="font-mono">{revokedAt}</span>
						</span>
					)}
				</MetaLine>
			</div>
		</QueueRow>
	);
}

export function ArchivedManuals({ manuals }: { manuals: MedicoFila["archivedManuals"] }) {
	if (manuals.length === 0) {
		return null;
	}

	return (
		<QueueSection
			title={MedicoLabels.archivedManuals.title}
			subtitle={MedicoLabels.archivedManuals.subtitle}
		>
			{manuals.map((manual) => (
				<ArchivedManualRow key={manual.id} manual={manual} />
			))}
		</QueueSection>
	);
}
